import { useSelector } from 'react-redux';
import { ReactPortalElementId } from 'core/layouts/types';
import { selectFeatureFlags, selectShouldShowGdprBanner } from 'core/userContext';
import { AnnouncementsContainer } from './Announcements.styled';
import { GdprAnnouncement } from './GdprAnnouncement';
import { SamlLockoutAnnouncement } from './SamlLockoutAnnouncement';
import { TrialEndDateBannerAnnouncement } from './TrialEndDateBannerAnnouncement';

export const TEXT = {
  TEST_ID: 'announcements',
};

export const Announcements = () => {
  const shouldShowGdprBanner = useSelector(selectShouldShowGdprBanner);
  /** SamlLockoutWarning is a FF that will be enabled only for those orgs that have not yet
   * migrated to the new SSO method. Once all orgs have migrated, this FF will be removed.
   */
  const { SamlLockoutWarning } = useSelector(selectFeatureFlags);

  return (
    <AnnouncementsContainer data-test={TEXT.TEST_ID} id={ReactPortalElementId.announcements}>
      {shouldShowGdprBanner && <GdprAnnouncement />}
      {SamlLockoutWarning && <SamlLockoutAnnouncement />}
      <TrialEndDateBannerAnnouncement />
    </AnnouncementsContainer>
  );
};
